import script from "./CommentField.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommentField.vue?vue&type=script&setup=true&lang=ts"

import "./CommentField.vue?vue&type=style&index=0&id=17255d00&scoped=true&lang=css"

import exportComponent from "/home/runner/work/binity-order/binity-order/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17255d00"]])

export default __exports__